import { useConsoleState } from "providers/ConsoleStateProvider";
import { useHistory } from "react-router-dom";

export const useReturnPage = () => {
  const { pageLevel } = useConsoleState();
  const history = useHistory();

  const returnPage = () => {
    switch (pageLevel) {
      case "0":
        history.replace(`/subject`);
        break;
      case "3":
        history.replace(`/subject`);
        break;
      case "4":
        history.replace(`/interview`);
        break;
      case "G":
        history.replace(`/subject`);
        break;
      case "R":
        return;
      default:
        history.replace(`/auth/login`);
        break;
    }
  };

  const getPageNameToReturn = () => {
    switch (pageLevel) {
      case "0":
        return "案件";
      case "3":
        return "案件";
      case "4":
        return "案件詳細";
      case "G":
        return "案件";
      case "R":
        return;
      default:
        return "ログイン画面";
    }
  };

  return { returnPage, getPageNameToReturn };
};
